// redux
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Link, Route, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import logo from '../images/logo.png';
import { createCategoryStructure, getItemById, isMobile, isTablet } from '../lib/util';
import NavigationMenu from '../components/NavigationMenu';
import MegaMenu from '../components/MegaMenu';
import './NavigationBar.css';
import SearchInput from '../components/SearchInput';
import MobileMenu from '../components/MobileMenu';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faSearch from '@fortawesome/fontawesome-free-solid/faSearch';

class NavigationBar extends Component {
  constructor() {
    super();
    this.state = {
      searchExpanded: false,
      mobileMenuActive: false,
      onTop: true,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, false);
  }

  handleScroll = () => {
    // Navbar is 60px in height. Could also get height of DOM node here using
    // findDOMNode(this.refs.navRef) and subtract that.

    // var heightToShow = window.innerHeight - 100;
    const threshold = 80;

    if (window.pageYOffset > threshold) {
      this.setState({ onTop: false });
    }

    if (window.pageYOffset <= threshold) {
      this.setState({ onTop: true });
    }
  };

  toggleSearch = (paramObj) => {
    const { closeOnly } = paramObj;
    this.setState({
      searchExpanded: !this.state.searchExpanded,
    }, () => {
      if (this.state.searchExpanded) {
        document.getElementById('SearchInput-input').focus();
      }
    });
    if (closeOnly) {
      this.setState({
        searchExpanded: false,
      });
    }
  };

  toggleMobileMenu = () => {
    // bulma specification - mobile max 768px
    if (isTablet() || isMobile()) {
      this.setState({
        mobileMenuActive: !this.state.mobileMenuActive,
      });
    }
  };

  closeMobileMenu = () => {
    this.setState({
      mobileMenuActive: false,
    });
  };

  createMenuList = (paramObj) => {
    const { structure, parentPath } = paramObj;

    return structure.map((elem) => {
      if (elem.product) {
        return (
          <li key={`menu${elem.product.name}`}>
            <Link to="/product" className="navbar-item">
              {elem.product.name}
            </Link>
          </li>
        );
      }
      const category = getItemById({
        id: elem.id,
        array: this.props.categories,
        key: 'category_ID',
      });
      if (elem.children.length > 0) {
        return (
          <li key={`menu${category.name}`}>
            <Link to={`${parentPath}/${category.category_ID}`} className="navbar-item">
              {category.name}
            </Link>
            <ul>
              {this.createMenuList({
                structure: elem.children,
                parentPath: `${parentPath}/${category.category_ID}`,
              })}
            </ul>
          </li>
        );
      }
      return (
        <li key={`menu${category.name}`}>
          <Link to={`${parentPath}/${category.category_ID}`} className="navbar-item">
            {category.name}
          </Link>
        </li>
      );
    });
  };

  render() {
    const structure = createCategoryStructure({
      categories: this.props.categories,
      products: this.props.products,
    });

    const searchClassName = classNames({
      'full-site-search': true,
      'is-active': this.state.searchExpanded,
    });

    const NavigationBarClass = classNames({
      NavigationBar: true,
      'not-on-top': !this.state.onTop,
    });

    const naviSearchClassName = classNames({
      'navbar-item ': true,
      'navbar-item--search': true,
      'is-active': this.state.searchExpanded,
    });

    return (
      <div className={NavigationBarClass}>
        <nav className="navbar" aria-label="main navigation">
          <div className="navbar-inner-wrapper">
            <div className="navbar-brand">
              <Link className="navbar-item" to="/" onClick={this.closeMobileMenu}>
                <img src={logo} className="logo" alt="logo" />
              </Link>
            </div>
            <div
              className="navbar-mobile-search"
              onClick={() => {
                this.closeMobileMenu();
                this.toggleSearch({ closeOnly: false });
              }}
              role="button"
              tabIndex="0"
            >
              <span className="icon">
                <FontAwesomeIcon icon={faSearch} />
              </span>
            </div>
            <div
              className={`navbar-burger ${this.state.mobileMenuActive ? 'is-active' : ''}`}
              onClick={() => {
                this.toggleSearch({ closeOnly: true });
                this.toggleMobileMenu();
              }}
              role="button"
              tabIndex="0"
            >
              <span />
              <span />
              <span />
            </div>
            <div className="navbar-menu">
              <div className="navbar-start">
                <Route
                  render={properties => (
                    <NavigationMenu
                      title="關於我們"
                      to="/about/us"
                      activeKey="about"
                      toggleSearch={this.toggleSearch}
                      {...properties}
                    />
                  )}
                />
                <Route
                  render={properties => (
                    <MegaMenu
                      title="產品介紹"
                      to="/catalog/1"
                      structure={structure}
                      toggleSearch={this.toggleSearch}
                      {...this.props}
                      {...properties}
                    />
                  )}
                />
                <Route
                  render={properties => (
                    <NavigationMenu
                      title="銷售據點"
                      to="/locations"
                      activeKey="locations"
                      toggleSearch={this.toggleSearch}
                      {...properties}
                    />
                  )}
                />
                <Route
                  render={properties => (
                    <NavigationMenu
                      title="產品登錄"
                      to="/register"
                      activeKey="register"
                      toggleSearch={this.toggleSearch}
                      {...properties}
                    />
                  )}
                />
                <Route
                  render={properties => (
                    <NavigationMenu
                      title="最新消息"
                      to="/news/all"
                      activeKey="news"
                      toggleSearch={this.toggleSearch}
                      {...properties}
                    />
                  )}
                />
                <Route
                  render={properties => (
                    <NavigationMenu
                      title="聯絡我們"
                      to="/contact"
                      activeKey="contact"
                      toggleSearch={this.toggleSearch}
                      {...properties}
                    />
                  )}
                />
                <div
                  className={naviSearchClassName}
                  role="button"
                  tabIndex="-1"
                  onClick={this.toggleSearch}
                >
                  <span className="navbar-item__search" />
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div className={searchClassName}>
          <Route
            render={properties => <SearchInput toggleSearch={this.toggleSearch} {...properties} />}
          />
        </div>
        <Route
          render={properties => (
            <MobileMenu
              active={this.state.mobileMenuActive}
              toggleMobileMenu={this.toggleMobileMenu}
              {...properties}
            />
          )}
        />
      </div>
    );
  }
}

NavigationBar.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = state => ({
  categories: state.categories,
  products: state.products,
});

export default withRouter(connect(mapStateToProps)(NavigationBar));



// WEBPACK FOOTER //
// ./src/containers/NavigationBar.js